var AppConstant = /** @class */ (function () {
    function AppConstant() {
    }
    AppConstant.API_ENDPOINT = 'http://192.168.1.72:8001';
    AppConstant.AWS_API_ENDPOINT = 'https://5dcu5nrgze.execute-api.ap-south-1.amazonaws.com/Development'; // live
    AppConstant.AWS_XQUARA_API_ENDPOINT = 'https://ivi5oq8umf.execute-api.ap-south-1.amazonaws.com/stage'; // live
    AppConstant.IMG_PATH = '/uploads';
    AppConstant.TEAM_ACCURACY = [{ id: 1, text: 'High' }, { id: 2, text: 'Low' }, { id: 3, text: 'Medium' }];
    AppConstant.Distance = [{ id: 1, text: 'Kilometer' }, { id: 2, text: 'Miles' }];
    AppConstant.Currency = [{ id: 1, text: 'INR' },
        { id: 2, text: 'USD' },
        { id: 3, text: 'EUR' },
        { id: 4, text: 'CAD' },
        { id: 5, text: 'KES' },
        { id: 6, text: 'RM' },
        { id: 7, text: 'SLL' },
        { id: 8, text: 'SAR' },
        { id: 9, text: 'AED' },
        { id: 10, text: 'ZWD' },
        { id: 11, text: 'KD' },
        { id: 12, text: 'GHC' },
        { id: 13, text: 'NGN' },
        { id: 14, text: 'PHP' },
        { id: 15, text: 'AUD' },
        { id: 16, text: 'AFA' },
        { id: 17, text: 'ALL' },
        { id: 18, text: 'DZD' },
        { id: 19, text: 'USD/ESP' },
        { id: 20, text: 'FAF/ADP' },
        { id: 21, text: 'AON' },
        { id: 22, text: 'XCD' },
        { id: 23, text: 'ARS' },
        { id: 24, text: 'AMD' },
        { id: 25, text: 'AWG' },
        { id: 26, text: 'ATS' },
        { id: 27, text: 'AZM' },
        { id: 28, text: 'BSD' },
        { id: 29, text: 'BHD' },
        { id: 30, text: 'BDT' },
        { id: 31, text: 'BBD' },
        { id: 32, text: 'BYB' },
        { id: 33, text: 'BEF' },
        { id: 34, text: 'BZD' },
        { id: 35, text: 'XOF' },
        { id: 36, text: 'BMD' },
        { id: 37, text: 'INR / BTN' },
        { id: 38, text: 'BOB' },
        { id: 39, text: 'BWP' },
        { id: 40, text: 'NOK' },
        { id: 41, text: 'BRL' },
        { id: 42, text: 'BND' },
        { id: 43, text: 'BGL' },
        { id: 44, text: 'BIF' },
        { id: 45, text: 'KHR' },
        { id: 46, text: 'XAF' },
        { id: 47, text: 'CVE' },
        { id: 48, text: 'CYD' },
        { id: 49, text: 'CLP' },
        { id: 50, text: 'CNY' },
        { id: 51, text: 'COP' },
        { id: 52, text: 'KMF' },
        { id: 53, text: 'NZD' },
        { id: 54, text: 'CRC' },
        { id: 55, text: 'HRK' },
        { id: 56, text: 'CUP' },
        { id: 57, text: 'CYP' },
        { id: 58, text: 'CZK' },
        { id: 59, text: 'DKK' },
        { id: 60, text: 'DJF' },
        { id: 61, text: 'DOP' },
        { id: 62, text: 'TPE / IDR' },
        { id: 63, text: 'ECS' },
        { id: 64, text: 'SVC' },
        { id: 65, text: 'EEK' },
        { id: 66, text: 'ETB' },
        { id: 67, text: 'FKP' },
        { id: 68, text: 'DKK' },
        { id: 69, text: 'FJD' },
        { id: 70, text: 'FIM' },
        { id: 71, text: 'FRF' },
        { id: 72, text: 'XPF' },
        { id: 73, text: 'GMD' },
        { id: 74, text: 'GEL' },
        { id: 75, text: 'DEM' },
        { id: 76, text: 'GIP' },
        { id: 77, text: 'GRD' },
        { id: 78, text: 'GTQ' },
        { id: 79, text: 'GNF' },
        { id: 80, text: 'GWP' },
        { id: 81, text: 'GYD' },
        { id: 82, text: 'HTG / USD' },
        { id: 83, text: 'HNL' },
        { id: 84, text: 'HKD' },
        { id: 85, text: 'HUF' },
        { id: 86, text: 'ISK' },
        { id: 87, text: 'IDR' },
        { id: 88, text: 'IRR' },
        { id: 89, text: 'IQD' },
        { id: 90, text: 'IRP' },
        { id: 91, text: 'ILS' },
        { id: 92, text: 'ITL' },
        { id: 93, text: 'JMD' },
        { id: 94, text: 'JPY' },
        { id: 95, text: 'KZT' },
        { id: 96, text: 'KES' },
        { id: 97, text: 'KPW' },
        { id: 98, text: 'KRW' },
        { id: 99, text: 'KWD' },
        { id: 100, text: 'KGS' },
        { id: 101, text: 'LAK' },
        { id: 102, text: 'LVL / LVR' },
        { id: 103, text: 'LBP' },
        { id: 104, text: 'ZAR / ZAL' },
        { id: 105, text: 'LBD' },
        { id: 106, text: 'LYD' },
        { id: 107, text: 'CHF' },
        { id: 108, text: 'LTL' },
        { id: 109, text: 'LUF' },
        { id: 110, text: 'MOD' },
        { id: 111, text: 'MKD' },
        { id: 112, text: 'MGF' },
        { id: 113, text: 'MWK' },
        { id: 114, text: 'MYR' },
        { id: 115, text: 'MVR' },
        { id: 116, text: 'MTL' },
        { id: 117, text: 'MRO' },
        { id: 118, text: 'MUR' },
        { id: 119, text: 'MXN' },
        { id: 120, text: 'MDL' },
        { id: 121, text: 'MNT' },
        { id: 122, text: 'MAD' },
        { id: 123, text: 'MZM' },
        { id: 124, text: 'MMK' },
        { id: 125, text: 'ZAR / NAD' },
        { id: 126, text: 'NPR' },
        { id: 127, text: 'NLG' },
        { id: 128, text: 'ANG' },
        { id: 129, text: 'NIO' },
        { id: 130, text: 'OMR' },
        { id: 131, text: 'PKR' },
        { id: 132, text: 'PAB / USD' },
        { id: 133, text: 'PGK' },
        { id: 134, text: 'PYG' },
        { id: 135, text: 'PEN' },
        { id: 136, text: 'PLZ' },
        { id: 137, text: 'PTE' },
        { id: 138, text: 'QAR' },
        { id: 139, text: 'ROL' },
        { id: 140, text: 'RUR' },
        { id: 141, text: 'RWF' },
        { id: 142, text: 'SHP' },
        { id: 143, text: 'WST' },
        { id: 144, text: 'STD' },
        { id: 145, text: 'SCR' },
        { id: 146, text: 'SGD' },
        { id: 147, text: 'SKK' },
        { id: 148, text: 'SIT' },
        { id: 149, text: 'SBD' },
        { id: 150, text: 'SOS' },
        { id: 151, text: 'ZAR' },
        { id: 152, text: 'LKR' },
        { id: 153, text: 'SDP / SDD' },
        { id: 154, text: 'SRG' },
        { id: 155, text: 'SZL' },
        { id: 156, text: 'SEK' },
        { id: 157, text: 'CHF' },
        { id: 158, text: 'SYP' },
        { id: 159, text: 'TWD' },
        { id: 160, text: 'TZS' },
        { id: 161, text: 'THB' },
        { id: 162, text: 'TOP' },
        { id: 163, text: 'TTD' },
        { id: 164, text: 'TND' },
        { id: 165, text: 'TRL' },
        { id: 166, text: 'TMM' },
        { id: 167, text: 'UGX' },
        { id: 168, text: 'UAK' },
        { id: 169, text: 'GBP' },
        { id: 170, text: 'UYU' },
        { id: 171, text: 'UZS' },
        { id: 172, text: 'VUV' },
        { id: 173, text: 'VEB' },
        { id: 174, text: 'VND' },
        { id: 175, text: 'MAD' },
        { id: 176, text: 'YER' },
        { id: 177, text: 'YUN' },
        { id: 178, text: 'ZRN' },
        { id: 179, text: 'ZMK' },
        { id: 180, text: 'EGP' }];
    AppConstant.BUSSINESS_TYPE = { PICKUP: 1, APPOINTMENT: 2, FIELD: 3 };
    AppConstant.categorys = [{ id: 4, text: 'All Category' }, { id: 1, text: 'Pickup & Delivery' }, {
            id: 2, text: 'Appointment'
        }, { id: 3, text: 'Field Workforce' }];
    AppConstant.templatecategorys = [{ id: 1, text: 'Pickup & Delivery' }, {
            id: 2, text: 'Appointment'
        }, { id: 3, text: 'Field Workforce' }];
    AppConstant.BUSINESS_NAMES = { 1: 'pickupDelivery', 2: 'appointment', 3: 'fieldWorkforce' };
    AppConstant.TRACK_BUSINESS_TYPES = { 'Pickup & Delivery': 1, 'Appointment': 2, 'Field Workforce': 3 };
    // TODO change auto allocation model
    AppConstant.AUTO_ALLOCATION = { ONEBYONE: 1, SENDTOALL: 2, NEAREST: 3 };
    AppConstant.isPickUp = { PICKUP: true, DELIVERY: false };
    AppConstant.isDriverEarning = { DRIVEREARNING: 1, TASKPRICING: 2, DAILYPRICING: 3, MERCHANTPRICING: 4, MANUALPRICING: 5 };
    AppConstant.driverType = { INSTORE: 1, FREELANCE: 2 };
    AppConstant.isDistanceTravelled = { KILOMETER: 'KM', MILES: 'MI', OTHER: 'OTH' };
    AppConstant.EXPORT_TASKS = { All_Tasks: 1, Todays_Task: 2, Custom_Selection: 3 };
    AppConstant.STATUS_COLORS = {
        IDLE: '#0abe51',
        BLOCKED: '#8a8a8a',
        INTRANSIT: '#f9a825',
        OFFLINE: '#e65100',
        // FIRST_LOGIN: '#4caf5',
        UNASSIGNED: '#26c6da',
        ASSIGNED: '#f57f17',
        ACCEPTED: '#4caf50',
        STARTED: '#03a9f4',
        ARRIVED: '#f9a825',
        SUCCESS: '#388e3c',
        FAILED: '#dd2c00',
        DECLINED: '#e65100',
        CANCELLED: '#3e2723',
        CREATED: '#800080',
        ACKNOWLEDGE: '#1a508e'
    };
    AppConstant.WEBHOOK_TRIGGER = [
        { id: 1, text: 'Task unassigned' },
        { id: 2, text: 'Task assigned' },
        { id: 3, text: 'Task accepted' },
        { id: 4, text: 'Task started' },
        { id: 5, text: 'Task arrived' },
        { id: 6, text: 'Task completed' },
        { id: 7, text: 'Task failed' },
        { id: 8, text: 'Task declined' },
        { id: 9, text: 'Task cancelled' },
        { id: 10, text: 'Task acknowledge' },
        { id: 14, text: 'Task deleted' },
        { id: 25, text: 'Task updated' }
    ];
    AppConstant.TRANSPORT = { BIKE: 1, CAR: 2, TRUCK: 3, SCOOTER: 4, CYCLE: 5, WALK: 6 };
    AppConstant.TRANSPORT_NAMES = {
        1: 'DRIVING',
        2: 'DRIVING',
        3: 'DRIVING',
        4: 'DRIVING',
        5: 'BICYCLING',
        6: 'WALKING'
    };
    AppConstant.TASK_STATUS = [{ id: 1, status: 'UNASSIGNED', text: 'Unassigned', color: '#26c6da' },
        { id: 2, status: 'ASSIGNED', text: 'Assigned', color: '#f57f17' },
        { id: 3, status: 'ACCEPTED', text: 'Accepted', color: '#4caf50' },
        { id: 4, status: 'STARTED', text: 'Started', color: '#03a9f4' },
        { id: 5, status: 'ARRIVED', text: 'Arrived', color: '#f9a825' },
        { id: 6, status: 'SUCCESSFUL', text: 'Successful', color: '#388e3c' },
        { id: 7, status: 'FAILED', text: 'Fail', color: '#dd2c00' },
        { id: 8, status: 'DECLINED', text: 'Declined', color: '#e65100' },
        { id: 9, status: 'CANCELLED', text: 'Cancelled', color: '#3e2723' },
        { id: 10, status: 'ACKNOWLEDGED', text: 'Acknowledged', color: '#1a508e' },
        { id: 30, status: 'CUSTOMER NOT AVAILABLE', text: 'Customer not available', color: '#1a508e' }];
    AppConstant.DRIVER_STATUS_ARRY = [{ id: 1, status: 'IDLE', text: 'Idle', color: '#26c6da' },
        { id: 2, status: 'IN_TRANSIT', text: 'In_transit', color: '#f57f17' },
        { id: 3, status: 'OFFLINE', text: 'Offline', color: '#e65100' },
        { id: 4, status: 'BLOCKED', text: 'Blocked', color: '#8a8a8a' }];
    AppConstant.DELAY = [{ id: 1, delay: 5 }, { id: 2, delay: 15 }, { id: 3, delay: 25 }, { id: 4, delay: 45 }];
    AppConstant.map_Filter = [{ id: 1, itemName: 'Show Dark map', text: 'Show Dark map' },
        { id: 2, itemName: 'Show Satellite view', text: 'Show Satellite view' },
        { id: 3, itemName: 'Hide offline agent', text: 'Hide offline agent' },
        { id: 4, itemName: 'Hide completed task', text: 'Hide completed task' },
        { id: 5, itemName: 'Show traffic layer', text: 'Show traffic layer' }];
    AppConstant.DRIVER_STATUS = { FIRST_LOGIN: 0, IDLE: 1, IN_TRANSIT: 2, OFFLINE: 3, BLOCKED: 4 };
    AppConstant.MERCHANT_STATUS = { BLOCKED: 1, ACTIVE: 0 };
    AppConstant.STATUS_OF_TASKS = {
        'UNASSIGNED': 1,
        'ASSIGNED': 2,
        'ACCEPTED': 3,
        'STARTED': 4,
        'ARRIVED': 5,
        'SUCCESS': 6,
        'FAILED': 7,
        'DECLINED': 8,
        'CANCELLED': 9,
        'ACKNOWLEDGED': 10,
        'DELETED': 14
    };
    AppConstant.TASK_LOG_STATUS = {
        'created': 0,
        'unassigned': 1,
        'assigned': 2,
        'accepted': 3,
        'started': 4,
        'arrived': 5,
        'completed': 6,
        'failed': 7,
        'declined': 8,
        'cancelled': 9,
        'acknowledged': 10,
        'Image': 11,
        'Signature': 12,
        'deleted': 13,
        'Notes': 14,
        'Barcode': 15,
        'Notesupdated': 16,
        'Notedeleted': 17,
        'updated': 18
    };
    AppConstant.analysis_dateFilter = [
        { id: 1, text: 'Today' },
        { id: 2, text: 'Past Week' },
        { id: 3, text: 'Past Month' },
        { id: 4, text: 'Custom Date' }
    ];
    AppConstant.Ontime_Idle = { ONTIME: 0, IDLE: 1 };
    AppConstant.Role = { 'ADMIN': 1, 'Manager': 2, 'Driver': 3, 'Custom': 4 };
    AppConstant.PERMISSION = {
        'DRIVER_READ': 'DRIVER.READ',
        'DRIVER_WRITE': 'DRIVER.WRITE',
        'DRIVER_UPDATE': 'DRIVER.UPDATE',
        'DRIVER_DELETE': 'DRIVER.DELETE',
        'DRIVER_ALL_READ': 'DRIVER.ALL.READ',
        'DRIVER_IMPORT_WRITE': 'DRIVER.IMPORT.WRITE',
        'DRIVER_BLOCKUNBLOCK_UPDATE': 'DRIVER.BLOCKUNBLOCK.UPDATE',
        'DRIVER_DRIVERSTATUS_UPDATE': 'DRIVER.DRIVERSTATUS.UPDATE',
        'DASHBOARD_DRIVER_READ': 'DASHBOARD.DRIVER.READ',
        'DASHBOARD_DRIVERDETAILS_READ': 'DASHBOARD.DRIVERDETAILS.READ',
        'DASHBOARD_REASSIGNTASK_UPDATE': 'DASHBOARD.REASSIGNTASK.UPDATE',
        'DASHBOARD_TASK_READ': 'DASHBOARD.TASK.READ',
        'DASHBOARD_TASKDETAILS_READ': 'DASHBOARD.TASKDETAILS.READ',
        'DASHBOARD_TASKLOG_READ': 'DASHBOARD.TASKLOG.READ',
        'TASK_READ': 'TASK.READ',
        'TASK_UPDATE': 'TASK.UPDATE',
        'TASK_WRITE': 'TASK.WRITE',
        'TASK_IMPORT_WRITE': 'TASK.IMPORT.WRITE',
        'TASK_DELETE': 'TASK.DELETE',
        'TASK_CHANGESTATUS_UPDATE': 'TASK.CHANGESTATUS.UPDATE',
        'TASK_TASKDELETE_DELETE': 'TASK.TASKDELETE.DELETE',
        'TEAM_READ': 'TEAM.READ',
        'TEAM_WRITE': 'TEAM.WRITE',
        'TEAM_UPDATE': 'TEAM.UPDATE',
        'TEAM_DELETE': 'TEAM.DELETE',
        'TEAM_ALL_READ': 'TEAM.ALL.READ',
        'CUSTOMER_READ': 'CUSTOMER.READ',
        'MANAGER_READ': 'MANAGER.READ',
        'HELP_READ': 'HELP.READ',
        'SET_APPSETUP_READ': 'SETTINGS.APP.READ',
        'SET_APPSETUP_UPDATE': 'SETTINGS.APP.UPDATE',
        'SET_AUTOALLOC_READ': 'SETTINGS.ALLOCATION.READ',
        'SET_AUTOALLOC_UPDATE': 'SETTINGS.ALLOCATION.UPDATE',
        'SET_CATEGORY_READ': 'SETTINGS.CATEGORY.READ',
        'SET_CATEGORY_UPDATE': 'SETTINGS.CATEGORY.UPDATE',
        'SET_DEV_READ': 'SETTINGS.DEVELOPER.READ',
        'SET_NOT_READ': 'SETTINGS.NOTIFICATION.READ',
        'SET_NOT_UPDATE': 'SETTINGS.NOTIFICATION.UPDATE',
        'SET_PREF_READ': 'SETTINGS.PREFERENCE.READ',
        'SET_PREF_UPDATE': 'SETTINGS.PREFERENCE.UPDATE',
        'SET_PROFILE_READ': 'SETTINGS.PROFILE.READ',
        'SET_PROFILE_UPDATE': 'SETTINGS.PROFILE.UPDATE',
        'SET_CHANGEPASS_UPDATE': 'SETTINGS.CHANGE-PASSWORD.UPDATE',
        'SET_BILLING_READ': 'SETTINGS.BILLING.READ',
        'TASK_EXPORT_READ': 'TASK.EXPORT.READ',
        'DRIVER_EXPORT_READ': 'DRIVER.EXPORT.READ',
        'CUSTOMER_ALL_READ': 'CUSTOMER.ALL.READ',
        'SET_EARNINGS_READ': 'SETTINGS.EARNINGS.READ',
        'SET_EARNINGS_WRITE': 'SETTINGS.EARNINGS.WRITE',
        'SET_EARNINGS_UPDATE': 'SETTINGS.EARNINGS.UPDATE',
        'SET_EARNINGS_DELETE': 'SETTINGS.EARNINGS.DELETE',
        'SET_GEOFENCE_READ': 'SETTINGS.GEOFENCE.READ',
        'SET_GEOFENCE_WRITE': 'SETTINGS.GEOFENCE.WRITE',
        'SET_GEOFENCE_UPDATE': 'SETTINGS.GEOFENCE.UPDATE',
        'SET_GEOFENCE_DELETE': 'SETTINGS.GEOFENCE.DELETE',
        'SET_GEOFENCE_EXPORT': 'SETTINGS.GEOFENCE.EXPORT',
        'MERCHANT_READ': 'MERCHANT.READ',
        'ANALYTICS_ONTIME_READ': 'ANALYTICS.ONTIME.READ',
        'PROJECT_READ': 'PROJECT.READ',
        'PROJECT_WRITE': 'PROJECT.WRITE',
        'PROJECT_UPDATE': 'PROJECT.UPDATE',
        'PROJECT_DELETE': 'PROJECT.DELETE',
        'PROJECT_PROJECTSTASKSLIST_READ': 'PROJECT.PROJECTSTASKSLIST.READ',
        'SET_FORMEDITOR_READ': 'SETTINGS.FORMEDITOR.READ',
        'SET_FORMEDITOR_WRITE': 'SETTINGS.FORMEDITOR.WRITE',
        'SET_FORMEDITOR_UPDATE': 'SETTINGS.FORMEDITOR.UPDATE',
        'SET_FORMEDITOR_DELETE': 'SETTINGS.FORMEDITOR.DELETE',
        'SET_FORMEDITOR_EXPORT': 'SETTINGS.FORMEDITOR.EXPORT',
    };
    AppConstant.PACKAGE_NAMES = {
        'plan1': { 'id': 1, 'name': 'STARTUPS', 'agentLimit': 3, 'taskLimit': '1000', 'price': '0' },
        'plan2': { 'id': 2, 'name': 'SME', 'taskLimit': 'Unlimited', 'price': '10/Driver/Month' },
        'plan3': { 'id': 3, 'name': 'ENTERPRISE', 'taskLimit': 'Unlimited', 'price': '10/Driver/Month' }
    };
    AppConstant.PACKAGE_NAME = {
        1: 'STARTUPS',
        2: 'SME',
        3: 'ENTERPRISE'
    };
    AppConstant.PACKAGE_NUMBERS = {
        'FREE': 1,
        'DRIVER': 2,
    };
    AppConstant.TASK_STATUS_BY_ID = {
        1: { id: 1, status: 'UNASSIGNED', text: 'Unassigned', color: '#26c6da' },
        2: { id: 2, status: 'ASSIGNED', text: 'Assigned', color: '#f57f17' },
        3: { id: 3, status: 'ACCEPTED', text: 'Accepted', color: '#4caf50' },
        4: { id: 4, status: 'STARTED', text: 'Started', color: '#03a9f4' },
        5: { id: 5, status: 'ARRIVED', text: 'Arrived', color: '#f9a825' },
        6: { id: 6, status: 'SUCCESSFUL', text: 'Successful', color: '#388e3c' },
        7: { id: 7, status: 'FAILED', text: 'Failed', color: '#dd2c00' },
        8: { id: 8, status: 'DECLINED', text: 'Declined', color: '#e65100' },
        9: { id: 9, status: 'CANCELLED', text: 'Cancelled', color: '#3e2723' },
        10: { id: 10, status: 'ACKNOWLEDGED', text: 'Acknowledged', color: '#1a508e' },
        14: { id: 14, status: 'DELETED', text: 'Deleted', color: '#1a508e' },
        11: { id: 30, status: 'CUSTOMER NOT AVAILABLE', text: 'Customer not available', color: '#1a508e' }
    };
    AppConstant.TRANSPORT_TYPES = [
        {
            id: 1,
            text: 'Bike'
        },
        {
            id: 2,
            text: 'Car'
        },
        {
            id: 3,
            text: 'Truck'
        },
        {
            id: 4,
            text: 'Scooter'
        },
        {
            id: 5,
            text: 'Cycle'
        },
        {
            id: 6,
            text: 'Walk'
        }
    ];
    return AppConstant;
}());
export { AppConstant };



//////////////////
// WEBPACK FOOTER
// ./src/app/app.constant.ts
// module id = ./src/app/app.constant.ts
// module chunks = main